import { useState } from "react";
import { Card, Row } from "reactstrap";
import { useAppSelector } from "../../../../../reduxToolkit/hooks";
import { getVisibleProducts } from "../../../../../utils/ecommerce";
import { ProductItems } from "../../../../../types/Ecommerce";
import { dynamicImage } from "../../../../../utils";
import HoverLinks from "./HoverLinks";
import ProductModal from "./productModal";
import Details from "./Details";
import { Image } from "../../../../../coreComponents/Image";
import SearchNotFoundClass from "../../../../../coreComponents/SearchNotFoundClass";

// This component displays a grid layout of products, allowing users to view and interact with them.
const GridView = () => {
  const { productItem } = useAppSelector((state) => state.product);
  const { listView, colClass } = useAppSelector((state) => state.filterData);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [dataId, setDataId] = useState<undefined | number>();
  const { filter } = useAppSelector((state) => state.filterData);
  const products = getVisibleProducts(productItem, filter);
  
  return (
    <div className={`product-wrapper-grid ${listView ? "list-view" : ""}`}>
      <Row className="gridRow">
        {products.length !== 0 ? (
          products.map((item: ProductItems, index: number) => {
            return (
              <div id="gridId" className={`${colClass} ${listView ? "col-xl-12" : ""}`} key={index}>
                <Card>
                  <div className="product-box">
                    <div className="product-img">
                      {item.status !== "none" && <div className={`${item.ribbonClassName}`}>{item.status}</div>}
                      <Image className="img-fluid" src={dynamicImage(item.image)} alt="" />
                      <HoverLinks setDataId={setDataId} setOpenModal={setOpenModal} item={item} />
                    </div>
                    <Details item={item} />
                  </div>
                </Card>
              </div>
            );
          })
        ) : (
          <SearchNotFoundClass word="Product" />
        )}
        {openModal && <ProductModal value={openModal} setOpenModal={setOpenModal} dataId={dataId} />}
      </Row>
    </div>
  );
};
export default GridView;
